import React from 'react'
import styled, { css } from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  valueStart: React.ReactNode
  valueEnd: React.ReactNode
  labelStart: string
  labelEnd: string
} & ClassNameProps

export const TransactionDetailsRow: React.FC<Props> = ({
  valueEnd,
  valueStart,
  labelStart,
  labelEnd,
  className,
}) => (
  <Root className={className}>
    <Column>
      <PrimaryText>{valueStart}</PrimaryText>
      <SecondaryText>{labelStart}</SecondaryText>
    </Column>
    <Column
      css={css`
        text-align: right;
      `}
    >
      <PrimaryText>{valueEnd}</PrimaryText>
      <SecondaryText>{labelEnd}</SecondaryText>
    </Column>
  </Root>
)

const Root = styled.div`
  color: var(--text-12);
  border-top: 1px solid rgba(255 255 255 / 5%);

  display: flex;
  justify-content: space-between;
  padding-block: 16px;
`

const Column = styled.div`
  display: grid;
`

const PrimaryText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const SecondaryText = styled.div`
  opacity: 0.5;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`
